import { render, staticRenderFns } from "./WorkTaskDeclineDialog.vue?vue&type=template&id=64e52fdb"
import script from "./WorkTaskDeclineDialog.vue?vue&type=script&lang=ts"
export * from "./WorkTaskDeclineDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports